import { ComponentClass } from 'react';
import { keyBy } from 'lodash';
import ShowProducts from '../show-products/ShowProducts';
import LessonSearch from '../lesson-search/LessonSearch';
import PupilDetails from '../pupil-details/PupilDetails';
import ErrorPage from '../error/ErrorPage';
import Payment from '../payment/Payment';
import Confirmation from '../confirmation/Confirmation';
import { RootState } from '../../app/store';

interface AppRoute {
    name: string;
    path: string;
    journeyStep: number;
    component: ComponentClass;
    isPreviousStepComplete: (state: RootState) => boolean;
}

export function isRouteSkippable() {
    return import.meta.env.VITE_ENV !== 'production'
        && import.meta.env.VITE_ENV !== 'uat';
}

export const appRoutes: AppRoute[] = [
    {
        name: 'products',
        path: '/products',
        journeyStep: 1,
        component: ShowProducts,
        isPreviousStepComplete: (state: RootState) => true
    },
    {
        name: 'pickup',
        path: '/pickup',
        journeyStep: 2,
        component: LessonSearch,
        isPreviousStepComplete: (state: RootState) =>
            state.userSelection.productId !== undefined
            || isRouteSkippable()
    },
    {
        name: 'details',
        path: '/details',
        journeyStep: 3,
        component: PupilDetails,
        isPreviousStepComplete: (state: RootState) =>
            state.userSelection.lessonTime !== undefined
            || isRouteSkippable()
    },
    {
        name: 'payment',
        path: '/payment',
        journeyStep: 4,
        component: Payment,
        isPreviousStepComplete: (state: RootState) =>
            state.userSelection.pupilDetails.purchaser !== undefined
            || isRouteSkippable()
    },
    {
        name: 'confirmation',
        path: '/confirmation',
        journeyStep: 4,
        component: Confirmation,
        isPreviousStepComplete: (state: RootState) =>
            state.payment.paymentResponse !== undefined
            || isRouteSkippable()
    },
    {
        name: 'errorPage',
        path: '/error',
        journeyStep: 0,
        component: ErrorPage,
        isPreviousStepComplete: (state: RootState) => true
    }
];

export const appRoutesByName = keyBy(appRoutes, 'name');